import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import Input from "../../../components/input";

const AddMoreBanner = ({
  isAddMoreOpen,
  closeAddMoreModal,
  uploadAndSaveImg,
}) => {
  const [img, setImg] = useState();
  const [error, setError] = useState("")

  const handleSave = () => {
    if (!img) {
      setError("Image required")
      return
    }
    uploadAndSaveImg(img, "add");
    closeAddMoreModal();
  };
  
  return (
    <Modal
      show={isAddMoreOpen}
      onHide={closeAddMoreModal}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Add a Banner</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Input
          label="Upload a new Banner image"
          type="file"
          accept="image/png, image/jpeg"
          value={img}
          onChange={(e) => setImg(e.target.files[0])}
        />
        {error && <div className="text-danger">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button text="Save Changes" callBack={handleSave} />
      </Modal.Footer>
    </Modal>
  );
};

export default AddMoreBanner;
